// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.e565ca53d',
  revision: 'e565ca53d',
  branch: 'develop',
  date: 'Mon, 21 Sep 2026 15:08:50 GMT'
};